<label class="manual-payment-card" [ngClass]="{ 'manual-payment-card--selected': isSelected() }">
  <input
    type="radio"
    [checked]="isSelected()"
    [disabled]="disabled()"
    class="manual-payment-card__radio-input"
    (change)="payWithPSE.emit()"
  />

  <div class="manual-payment-card__info">
    <h3 class="manual-payment-card__title">PSE / Tarjeta</h3>
    <p class="manual-payment-card__text">
      Realiza el pago con PSE o tarjeta. Deberás renovar manualmente el próximo periodo.
    </p>
  </div>
</label>
